import m from 'mithril'

export default {
  view: vnode => {
    const image = require('./image9.jpg')
    const map = require('./map.jpg')

    return (
      <div className={`log-book-page-content-inner log-book-page-template mod-07-page`}>
        <div className={`log-book-text-container ${vnode.attrs.unredacted ? 'is-unredacted' : 'is-redacted'}`}>
          <h3 className="log-book-text mod-h3">
            Aftalen om de amerikanske baser. 
          </h3>
          <p className="log-book-text">Grønland spiller en afgørende rolle i USA’s nye polarstrategi, der skal være med til at dæmme op for truslen fra Sovjet. Den 27. april 1951 indgår USA og Danmark en aftale omkring Grønland. I den såkaldte Grønlandsoverenskomst fastholder Danmark suveræniteten over Grønland, men USA får lov til at bygge baser inden for særlige militære områder.  Thule-området får tre amerikanske baser: Thule-basen, Camp Tuto og Camp Century. Men Camp Century ligger udenfor de områder USA og Danmark har aftalt. Under ‘Operation Blue Jay’ sejler en armada på 120 skibe med 12.000 mand fra Virginia til Grønland. USA gør det klart, at man i Thule vil opstille bombefly af typerne B-47 Stratojet eller B-36 Peacemaker. Begge fly kan bære atomvåben. </p>
         

          <figure className="log-book-figure">
            <img src={map} className="log-book-img" />
            <figcaption className="log-book-figcaption">
              Amerikanske baser i Thuleområdet i 1962
            </figcaption>
          </figure>
          <p className="log-book-text">Under ‘Operation Blue Jay’ sejler en armada på 120 skibe med 12.000 mand fra Virginia til Grønland. USA gør det klart, at man i Thule vil opstille bombefly af typerne B-47 Stratojet eller B-36 Peacemaker. Begge fly kan bære atomvåben.</p>
          <figure className="log-book-figure">
            <img src={image} className="log-book-img" />
            <figcaption className="log-book-figcaption">
              Foto fra Operation Blue Jay
            </figcaption>
          </figure>
        </div>
      </div>
    )
  }
}
